<template>
    <div :class="inputClass">
        <div v-for="(option, index) in options" :key="index">
            <input
                :id="optionId(option)"
                :checked="isOptionChecked(option)"
                :data-checked="isOptionChecked(option)"
                :name="_uid"
                :value="option.value"
                :autofocus="hasAutofocus"
                :required="isRequired"
                type="radio"
                :disabled="isDisabled"
                @change="change($event)"
            />

            <label :for="optionId(option)">
                <span>{{ option.label }}</span>
            </label>
        </div>
    </div>
</template>

<script>
    import RadioInput from 'components/form-inputs/RadioInput'

    export default {
        extends: RadioInput,

        props: {
            size: { type: String, required: true },
        },

        computed: {
            inputClass() {
                return {
                    'form-input-tabs': true,
                    'form-input-tabs--is-disabled': this.isDisabled,
                    [`form-input-tabs--size-${this.size}`]: this.size,
                }
            },
        },
    }
</script>
